import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { applyGroupedDataPage, applyGroupFetchRejected } from 'src/redux/common/reducers';
import { getQuotes, getQuotesByFilter, getQuotesForGroup } from 'src/redux/quotes/api';
import type {
  InitialQuoteStateType,
  QuoteAPIResponseObj,
  QuoteDataObj,
} from 'src/redux/quotes/types';

const extraReducers = (builder: ActionReducerMapBuilder<InitialQuoteStateType>) => {
  // users list page filter options
  builder.addCase(getQuotes().pending, (state: InitialQuoteStateType, action) => {
    if (!action.meta.arg.quoteId) {
      state.isLoading = true;
      state.currentFilterReferenceObj = action.meta.arg;
    }
  });
  builder.addCase(getQuotes().fulfilled, (state: InitialQuoteStateType, action) => {
    const newSource = { ...(state?.source || {}) };
    const newTagSource = { ...(state?.tagSource || {}) };
    const newQuoteIds = [...(Number(action.meta.arg.page || 0) > 1 ? state?.data?.data || [] : [])];

    action?.payload?.data?.forEach((item: QuoteAPIResponseObj) => {
      if (!newQuoteIds?.includes(item?.quote_id)) {
        newQuoteIds.push(item?.quote_id);
      } else {
        newQuoteIds.splice(newQuoteIds.indexOf(item?.quote_id), 1);
      }
      // if the quoteId contains in the argument, it means
      //  the api called due to pusher update. so we don't need to update meta.
      newSource[item?.quote_id] = {
        ...item,
        tags: item?.tags?.map((tag) => {
          newTagSource[tag?.tag_id] = tag;
          return tag?.tag_id;
        }),
      };
    });

    if (!action.meta.arg.quoteId) {
      state.data = {
        data: newQuoteIds,
        meta: action?.payload?.meta || {},
      };
    }
    state.tagSource = newTagSource;
    state.source = newSource;
    state.isLoading = false;
  });
  builder.addCase(getQuotes().rejected, (state: InitialQuoteStateType) => {
    state.isLoading = false;
  });

  // Fetch Quotes by filter
  builder.addCase(getQuotesByFilter().pending, (state: InitialQuoteStateType) => {
    state.isFetchingQuotes = true;
  });
  builder.addCase(getQuotesByFilter().fulfilled, (state: InitialQuoteStateType) => {
    state.isFetchingQuotes = false;
  });
  builder.addCase(getQuotesByFilter().rejected, (state: InitialQuoteStateType) => {
    state.isFetchingQuotes = false;
  });
  builder.addCase(getQuotesForGroup().fulfilled, (state: InitialQuoteStateType, action) => {
    const groupKey = action.payload?._group_key as string | undefined;
    if (!groupKey) return;
    const items: QuoteAPIResponseObj[] = action.payload?.data ?? [];
    const meta = action.payload?.meta;

    items.forEach((quote) => {
      state.source[quote.quote_id] = {
        ...quote,
        tags: (quote as QuoteAPIResponseObj).tags?.map((tag) => {
          state.tagSource[tag.tag_id] = tag;
          return tag.tag_id;
        }),
      } as unknown as QuoteDataObj;
    });

    const newIds = items.map((quote) => quote.quote_id);
    applyGroupedDataPage(
      state,
      groupKey,
      newIds,
      meta,
      action.payload?._attempt as number | undefined,
    );
  });

  builder.addCase(getQuotesForGroup().rejected, (state: InitialQuoteStateType, action) => {
    applyGroupFetchRejected(state, action);
  });
};
export default extraReducers;
